/**
 * Gift guide tabs.
 *
 * Switches between the panels without reloading, since every panel is already
 * in the page. Keyboard arrows move between tabs as well, so the control works
 * without a pointer.
 */

function bind(root) {
  const tabs = [...root.querySelectorAll('[data-gift-tab]')];
  const panels = [...root.querySelectorAll('[data-gift-panel]')];
  const shopAll = [...root.querySelectorAll('[data-gift-shop-all]')];
  if (tabs.length === 0) return;

  function show(index) {
    tabs.forEach((tab) => {
      const active = tab.dataset.giftTab === String(index);
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const active = panel.dataset.giftPanel === String(index);
      if (active) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });

    shopAll.forEach((link) => {
      link.hidden = link.dataset.giftShopAll !== String(index);
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => show(tab.dataset.giftTab));

    tab.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();

      const here = tabs.indexOf(tab);
      const step = event.key === 'ArrowRight' ? 1 : -1;
      const next = tabs[(here + step + tabs.length) % tabs.length];

      next.focus();
      show(next.dataset.giftTab);
    });
  });
}

function init() {
  document.querySelectorAll('.gift-guide').forEach((root) => {
    if (root.dataset.giftBound === 'true') return;
    root.dataset.giftBound = 'true';
    bind(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// The theme editor re-renders sections, so rebind when it does.
document.addEventListener('shopify:section:load', init);
